import React, { createContext, useState, useCallback, useRef } from 'react';

export const ScreenRecordingContext = createContext();

export const ScreenRecordingProvider = ({ children }) => {
  const [isRecording, setIsRecording] = useState(false);
  const [recordedImages, setRecordedImages] = useState([]);
  const streamRef = useRef(null);
  const intervalRef = useRef(null);

  const startRecording = useCallback((image, stream) => {
    setIsRecording(true);
    if (image) {
      setRecordedImages(prev => [...prev, image]);
    }
    if (stream) {
      streamRef.current = stream;
    }
  }, []);

  const stopRecording = useCallback(() => {
    // Stop the media stream
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }

    // Clear any running intervals
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    setIsRecording(false);
  }, []);

  const clearRecordedImages = useCallback(() => {
    setRecordedImages([]);
  }, []);

  // Cleanup on unmount
  React.useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
      }
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const value = {
    isRecording,
    recordedImages,
    startRecording,
    stopRecording,
    clearRecordedImages,
    setIntervalRef: (ref) => intervalRef.current = ref
  };

  return (
    <ScreenRecordingContext.Provider value={value}>
      {children}
    </ScreenRecordingContext.Provider>
  );
};